import { useTranslation } from 'react-i18next'

export default function AdminAnalytics() {
  const { t } = useTranslation('portal')
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">{t('admin.analytics.title')}</h1>
      <p className="text-gray-500">{t('admin.analytics.comingSoon')}</p>
    </div>
  )
}
